/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

import classNames from 'classnames';

import Tooltip from '../../../Tooltip';

import playIcon from '../../../../assets/images/video-player/play.svg';
import pauseIcon from '../../../../assets/images/video-player/pause.svg';
// import stopIcon from '../../../../assets/images/player-buttons/stop.svg';
import rewindIcon from '../../../../assets/images/video-player/rewind.svg';
import forwardIcon from '../../../../assets/images/video-player/forward.svg';
import volumeIcon from '../../../../assets/images/video-player/volume.svg';
import mutedVolumeIcon from '../../../../assets/images/video-player/mutedVolume.svg';
import fullscreenIcon from '../../../../assets/images/video-player/fullscreen.svg';
import subtitlesIcon from '../../../../assets/images/video-player/subtitles.svg';
import classes from './styles.module.scss';
import { useMeetingViewStore } from '../../../../store';

export default function Buttons({
  isRecording,
  stopVideoPlayer,
  startTimer,
  startVideoPlayer,
  pauseVideoPlayer,
  createSectionMode,
  isPlaying,
  isVideoReady,
  arePlayerButtonsVisible,
  videoRef,
  animateProgressBar,
  fullscreenContainerRef,
  onRewind,
  hasSubtitles,
  setAreSubtitlesEnabled,
  isEditPage,
  miniPlayer,
  secondaryVideoRef,
}) {
  const [isVideoMuted, setIsVideoMuted] = useState(false);

  const isVideoPlayerFixedMode = useMeetingViewStore(
    (state) => state.isVideoPlayerFixedMode
  );
  const setIsVideoPlayerFixedMode = useMeetingViewStore(
    (state) => state.setIsVideoPlayerFixedMode
  );

  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    const handleVolumeChange = () => {
      const ref = miniPlayer ? secondaryVideoRef : videoRef;

      if (ref?.current) {
      if (ref.current.muted) {
        setIsVideoMuted(true);
      } else {
        setIsVideoMuted(false);
        }
      }
    };

    const mainVideoRef = videoRef.current;
    const secondaryVideoRefCurrent = secondaryVideoRef?.current;

    mainVideoRef.addEventListener('volumechange', handleVolumeChange);
    if (secondaryVideoRefCurrent) {
      secondaryVideoRefCurrent.addEventListener(
        'volumechange',
        handleVolumeChange
      );
    }

    return () => {
      mainVideoRef.removeEventListener('volumechange', handleVolumeChange);
      if (secondaryVideoRefCurrent) {
        secondaryVideoRefCurrent.removeEventListener(
          'volumechange',
          handleVolumeChange
        );
      }
    };
  }, [videoRef, miniPlayer, secondaryVideoRef]);

  const startRecording = () => {
    if (!isRecording) {
      startTimer();
    }
  };

  const stopRecording = () => {
    if (isRecording) {
      stopVideoPlayer();
    }
  };

  const toggleMuteAudio = () => {
    const ref = miniPlayer ? secondaryVideoRef : videoRef;

    if (ref?.current) {
    ref.current.muted = !ref.current.muted;
    setIsVideoMuted(ref.current.muted);
    }
  };

  const rewindButtonHandler = () => {
    if (!videoRef.current) return;
    const newTime = videoRef.current.currentTime - 15;

    if (onRewind) {
      onRewind(newTime);
    }

    videoRef.current.currentTime = newTime;
  };

  const forwardButtonHandler = () => {
    if (!videoRef.current) return;
    const newTime = videoRef.current.currentTime + 30;

    if (onRewind) {
      onRewind(newTime);
    }
    videoRef.current.currentTime = newTime;
  };

  const toggleFullscreen = (event) => {
    event.stopPropagation();

    if (isVideoPlayerFixedMode) {
      setIsVideoPlayerFixedMode(false);
      return;
    }

    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    if (!fullscreenContainerRef?.current) {
      return;
    }

    if (fullscreenContainerRef.current.requestFullscreen) {
      fullscreenContainerRef.current.requestFullscreen();
    }
  };

  const showSubtitles = () => {
    if (hasSubtitles) {
      setAreSubtitlesEnabled((prevState) => !prevState);
    }
  };

  return (
    <div
      className={classNames(classes.Buttons, {
        [classes.chrome]: isChrome,
      })}
      style={{
        visibility:
          (isVideoReady || createSectionMode) && arePlayerButtonsVisible
            ? 'visible'
            : 'hidden',
      }}
    >
      <ul>
        {createSectionMode ? (
          <>
            {isRecording ? (
              <li>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={stopRecording}
                  className={classes.recordControl}
                >
                  <div className={classes.stopButton} />
                  <span>Stop Record</span>
                </div>
              </li>
            ) : (
              <li>
                <div
                  role="button"
                  className={classes.recordControl}
                  tabIndex={0}
                  onClick={startRecording}
                >
                  <div className={classes.recordButton} />
                  <span>Start Record</span>
                </div>
              </li>
            )}
          </>
        ) : (
          <>
            {isPlaying ? (
              <li>
                <button
                  type="button"
                  onClick={(event) => {
                    pauseVideoPlayer(event);
                    event.stopPropagation();
                  }}
                >
                  <img src={pauseIcon} alt="pause" />
                </button>
              </li>
            ) : (
              <li>
                <button
                  type="button"
                  onClick={(event) => {
                    startVideoPlayer(event);
                    event.stopPropagation();
                    animateProgressBar();
                  }}
                >
                  <img src={playIcon} alt="play" />
                </button>
              </li>
            )}
            <li>
              <button
                type="button"
                onClick={(event) => {
                  rewindButtonHandler();
                  event.stopPropagation();
                }}
              >
                <img src={rewindIcon} alt="Rewind" />
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={(event) => {
                  forwardButtonHandler();
                  event.stopPropagation();
                }}
              >
                <img src={forwardIcon} alt="Forward" />
              </button>
            </li>
            {!isEditPage && (
              <li className={classes.fullscreen}>
                <button type="button" onClick={toggleFullscreen}>
                  <img src={fullscreenIcon} alt="Fullscreen" />
                </button>
              </li>
            )}
            {!isEditPage && (
              <li className={classes.subtitles}>
                <button
                  type="button"
                  className={classes.subtitlesButton}
                  onClick={(event) => {
                    if (hasSubtitles) {
                      showSubtitles();
                    }
                    event.stopPropagation();
                  }}
                >
                  {hasSubtitles ? (
                    <img src={subtitlesIcon} alt="subtitles" />
                  ) : (
                    <Tooltip
                      text="Closed Captions are unavailable"
                      position="top-left"
                      width={300}
                    >
                      <img
                        src={subtitlesIcon}
                        className={classes.disabled}
                        alt="subtitles"
                      />
                    </Tooltip>
                  )}
                </button>
              </li>
            )}
            <li
              className={classNames(classes.mute, {
                [classes.edit]: isEditPage,
              })}
            >
              <button
                type="button"
                onClick={(event) => {
                  toggleMuteAudio();
                  event.stopPropagation();
                }}
              >
                <img
                  src={isVideoMuted ? mutedVolumeIcon : volumeIcon}
                  alt="Mute"
                />
              </button>
            </li>
            {/*  <li>
              <button type="button" onClick={stopVideoPlayer}>
                <img src={stopIcon} alt="stop" />
              </button>
            </li> */}
          </>
        )}
      </ul>
    </div>
  );
}
